import scheduler from "../services/booking.scheduler";
import schedulerForm from "../services/booking.scheduler.form.init";
import _ from "lodash";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        loading: false,
        errors: null,
        schedules: [],
        rooms: [],
        calendarEvents: [],
        eventStore: [],
        eventMonthStore: [],
        attendees: null,
        classOptions: [],
        instructorOptions: [],
        roomOptions: [],
        branchOptions: [],
        form: {},
        formLoaded: false,
        schedule: {
            color: null,
            class_name: null,
            category_name: null,
            schedule_date: null,
            branch_name: null,
            instructor_name: null,
            room_name: null,
            start_time: null,
            end_time: null,
            qrfilename: null
        },
        forceUpdate: false,
        calendarView: null
    },
    mutations: {
        loading(state) {
            state.loading = true;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        schedules(state, value) {
            state.schedules.push(value);
            state.schedules = _.flatten(state.schedules);
        },
        calendarEvents(state, value) {
            state.calendarEvents = value;
        },
        eventStore(state, value) {
            state.eventStore.push(value);
            state.eventStore = _.flatten(state.eventStore);
        },
        clearEventStore(state) {
            state.eventStore = [];
        },
        eventMonthStore(state, value) {
            state.eventMonthStore.push(value);
        },
        clearEventMonthStore(state) {
            state.eventMonthStore = [];
        },
        schedule(state, value) {
            state.schedule = value;
        },
        rooms(state, value) {
            state.rooms = value;
        },
        attendees(state, value) {
            state.attendees = value;
        },
        classOptions(state, value) {
            state.classOptions = value;
        },
        roomOptions(state, value) {
            state.roomOptions = value;
        },
        branchOptions(state, value) {
            state.branchOptions = value;
        },
        instructorOptions(state, value) {
            state.instructorOptions = value;
        },
        form(state, value) {
            state.form = value;
        },
        formLoaded(state, value) {
            state.formLoaded = value;
        },
        forceUpdate(state, value) {
            state.forceUpdate = value;
        },
        setCalendarView(state, value) {
            state.calendarView = value;
        },
        setQRcodeFilename(state, value) {
            state.schedule.qrfilename = value;
        }
    },
    actions: {
        async getSchedulesByMonth({ commit, state }, yearMonth) {
            commit("loading");
            try {
                // if (state.eventMonthStore.indexOf(yearMonth) === -1) {
                    // commit("eventMonthStore", yearMonth);
                    let response = await scheduler.getSchedulesByMonth(
                        yearMonth
                    );

                    let events = [];
                    let schedules = [];
                    _.forEach(response.list, function(value) {
                        let object = {
                            id: value.id,
                            uuid: value.uuid,
                            // startDate: value.schedule_date,
                            // title: value.class_name,
                            classes: value.color,
                            date: value.schedule_date,
                            startTime: value.start_time,
                            endTime: value.end_time,
                            name: value.class_name
                        };

                        let index = _.findIndex(state.eventStore, function(
                            data
                        ) {
                            return data.uuid === value.uuid;
                        });

                        //Add new schedule created
                        if (index === -1) {
                            events.push(object);
                            schedules.push(value);
                        }
                        //Force update schedule data
                        if (state.forceUpdate) {
                            let schedueIndex = _.findIndex(
                                state.schedules,
                                function(data) {
                                    return data.uuid === value.uuid;
                                }
                            );

                            if (schedueIndex !== -1) {
                                state.schedules[schedueIndex] = value;
                                state.eventStore[index] = object;
                            }
                        }
                    });
                    commit("schedules", schedules);
                    commit("calendarEvents", events);
                    commit("eventStore", events);
                    state.loading = false;
                // }
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async getSchedulesByWeek({ commit, state }, week) {
            commit("loading");
            try {
                let response = await scheduler.getSchedulesByWeek(
                    week
                );

                let events = [];
                let schedules = [];
                _.forEach(response.list, function(value) {
                    let object = {
                        id: value.id,
                        uuid: value.uuid,
                        classes: value.color,
                        date: value.schedule_date,
                        startTime: value.start_time,
                        endTime: value.end_time,
                        name: value.class_name
                    };

                    let index = _.findIndex(state.eventStore, function(
                        data
                    ) {
                        return data.uuid === value.uuid;
                    });

                    //Add new schedule created
                    if (index === -1) {
                        events.push(object);
                        schedules.push(value);
                    }
                    //Force update schedule data
                    if (state.forceUpdate) {
                        let schedueIndex = _.findIndex(
                            state.schedules,
                            function(data) {
                                return data.uuid === value.uuid;
                            }
                        );

                        if (schedueIndex !== -1) {
                            state.schedules[schedueIndex] = value;
                            state.eventStore[index] = object;
                        }
                    }
                });
                commit("schedules", schedules);
                commit("calendarEvents", events);
                commit("eventStore", events);
                state.loading = false;
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async getSchedulesByDay({ commit, state }, day) {
            commit("loading");
            try {
                let response = await scheduler.getSchedulesByDay(
                    day
                );

                let events = [];
                let schedules = [];
                _.forEach(response.list, function(value) {
                    let object = {
                        id: value.id,
                        uuid: value.uuid,
                        classes: value.color,
                        date: value.schedule_date,
                        startTime: value.start_time,
                        endTime: value.end_time,
                        name: value.class_name
                    };

                    let index = _.findIndex(state.eventStore, function(
                        data
                    ) {
                        return data.uuid === value.uuid;
                    });

                    //Add new schedule created
                    if (index === -1) {
                        events.push(object);
                        schedules.push(value);
                    }
                    //Force update schedule data
                    if (state.forceUpdate) {
                        let schedueIndex = _.findIndex(
                            state.schedules,
                            function(data) {
                                return data.uuid === value.uuid;
                            }
                        );

                        if (schedueIndex !== -1) {
                            state.schedules[schedueIndex] = value;
                            state.eventStore[index] = object;
                        }
                    }
                });
                commit("schedules", schedules);
                commit("calendarEvents", events);
                commit("eventStore", events);
                console.log(events);
                state.loading = false;
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async clearEventStore({ commit }) {
            commit("clearEventStore", []);
        },
        async clearCalendarEvent({ commit }) {
            commit("calendarEvents", []);
        },
        async refreshCalendar({ dispatch, state }, updatedPeriod) {
            // let index = state.eventMonthStore.indexOf(updatedPeriod);
            // if (index !== -1) {
            //     state.eventMonthStore.splice(index, 1);
            // }
            switch(state.calendarView) {
                case "Month":
                    await dispatch("getSchedulesByMonth", updatedPeriod);
                break;
                case "Day":
                    await dispatch("getSchedulesByDay", updatedPeriod);
                break;
                case "Week":
                    await dispatch("getSchedulesByWeek", updatedPeriod);
                break;
            }
            // await dispatch("getSchedulesByMonth", updatedPeriod);
        },
        async viewSchedule({ commit, state }, scheduleUuid) {
            commit("loading");
            try {
                let index = _.findIndex(state.schedules, function(data) {
                    return data.uuid === scheduleUuid;
                });
                commit("schedule", state.schedules[index]);
                commit("setQRcodeFilename", state.schedules[index].class_name.replace(/ /g, ""));
                state.loading = false;
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async getAttendees({ commit, state }, scheduleUuid) {
            commit("loading");
            try {
                let response = await scheduler.getAttendees(scheduleUuid);
                commit("attendees", response.list);
                state.loading = false;
            } catch (errors) {
                state.loading = false;
                commit("errors", errors);
            }
        },
        async getRoomOptions({ commit, state }) {
            commit("loading");
            try {
                let response = await scheduler.getRoomOptions();
                commit("rooms", response.options);
                // let options = [];
                // _.forEach(response.options, function(value) {
                //     let object = {
                //         value: value.id,
                //         text: value.name,
                //         branch_uuid: value.branch_uuid
                //     };
                //     options.push(object);
                // });
                // commit("roomOptions", options);
                state.loading = false;
            } catch (errors) {
                state.loading = false;
                commit("errors", errors);
            }
        },
        async getClassOptions({ commit, state }) {
            commit("loading");
            try {
                let response = await scheduler.getClassOptions();
                let options = [];
                _.forEach(response.options, function(value) {
                    let object = {
                        value: value.id,
                        text: value.name
                    };
                    options.push(object);
                });
                commit("classOptions", options);
                state.loading = false;
            } catch (errors) {
                state.loading = false;
                commit("errors", errors);
            }
        },
        async getInstructorOptions({ commit, state }) {
            commit("loading");
            try {
                let response = await scheduler.getInstructorOptions();
                let options = [];
                _.forEach(response.options, function(value) {
                    let object = {
                        value: value.id,
                        text: value.name
                    };
                    options.push(object);
                });
                commit("instructorOptions", options);
                state.loading = false;
            } catch (errors) {
                state.loading = false;
                commit("errors", errors);
            }
        },
        async getBranchOptions({ commit, state }) {
            commit("loading");
            try {
                let response = await scheduler.getBranchOptions();
                let options = [];
                _.forEach(response, function(value) {
                    let object = {
                        value: value.uuid,
                        text: value.name
                    };
                    options.push(object);
                });
                commit("branchOptions", options);
                state.loading = false;
            } catch (errors) {
                state.loading = false;
                commit("errors", errors);
            }
        },
        async initForm({ commit, state }) {
            let form = schedulerForm.formInit();
            form.instructorOptions = state.instructorOptions;
            form.selectedInstructor =
                state.instructorOptions.length > 0
                    ? state.instructorOptions[0].value
                    : null;
            form.classNameOptions = state.classOptions;
            form.selectedClassName =
                state.classOptions.length > 0
                    ? state.classOptions[0].value
                    : null;
            form.branchOptions = state.branchOptions;
            form.selectedBranch =
                state.branchOptions.length > 0
                    ? state.branchOptions[0].value
                    : null;
            form.capacity = 1;
            // form.roomOptions = state.roomOptions;
            // form.selectedRoom =
            //     state.roomOptions.length > 0
            //         ? state.roomOptions[0].value
            //         : null;
            commit("form", form);
            commit("formLoaded", true);
        },
        async createSchedule({ commit, state }, data) {
            commit("loading");
            commit("errors", null);
            try {
                let response = await scheduler.createSchedule(data);
                notification.success(response.message);
                state.loading = false;
            } catch (errors) {
                state.loading = false;
                if (errors.status === 400) {
                    notification.warning(errors.errors.message);
                } else {
                    notification.warning("Oops, cannot create schedule.");
                }
                console.log(errors);
                commit("errors", errors);
            }
        },
        async updateSchedule({ commit, state }, data) {
            commit("loading");
            commit("errors", null);
            try {
                let response = await scheduler.updateSchedule(data.uuid, data);
                notification.success(response.message);
                state.loading = false;
            } catch (errors) {
                state.loading = false;
                if (errors.status === 400) {
                    notification.warning(errors.errors.message);
                } else {
                    notification.warning("Oops, cannot update schedule.");
                }
                console.log(errors);
                commit("errors", errors);
            }
        }
    }
};
